import { initializeApp } from "firebase/app";
import { getAuth, OAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBqDw6SJjnuUnVyj0nZdYTp1ZmoLWnoft0",
  authDomain: "tma-sg-creativezenith-prod.firebaseapp.com",
  projectId: "tma-sg-creativezenith-prod",
  storageBucket: "tma-sg-creativezenith-prod.firebasestorage.app",
  messagingSenderId: "720878576926",
  appId: "1:720878576926:web:c7081626ceac708857d50f"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new OAuthProvider('microsoft.com');

provider.setCustomParameters({
    tenant: process.env.REACT_APP_TENANT_ID,
});

export { auth, provider };
